export class AnoLetivo {
  constructor({
    id = null,
    ano = null,
    dataInicio = null,
    dataFim = null,
  }) {
    this.id = id;
    this.ano = ano;
    this.dataInicio = this.formatData(dataInicio);
    this.dataFim = this.formatData(dataFim);
  }
  static Build() {
    return new AnoLetivo({
      id: null,
      ano: null,
      dataInicio: null,
      dataFim: null,
    });
  }
  format() {
    return this;
  }
  formatData(data) {
    if (data?.includes('T')) {
      data = data.split('T')[0];
    }
    return data;
  }
}
